import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml, Image } from '@bd/bdcore-utilities';
// import { H2Underdog } from '../../helpers/UIElements';

// import { colors } from '../../styles';

const styles = css `
  padding: 0;
  margin: 0;
  &.Image_bg {
    background-color: #ECECEC;
  }
  .WelcomeSection_lead {
    font-weight: 300;
    font-size: 18px;
    color: #000000;
    letter-spacing: 0;
    line-height: 32px;
    @media(min-width: 992px) {
      font-size: 21px;
      line-height: 40px;
    }
  }
  b {
    font-weight: 700;
  }
  .WelcomeSection_content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 60px 15px 55px;
    @media(min-width: 992px) {
      padding: 60px 50px;
      flex: 1;
    }
  }
  .WelcomeSection_image {
    max-width: 375px;
    height: 100%;
    margin: 0 auto;
    @media(min-width: 992px) {
      max-width: 500px;
    }
    @media(min-width: 1300px) {
      max-width: 600px;
    }
  }
`;

function WelcomeSection({ lead, image }) {
  return (
    <div className={`${styles} ${image ? 'Image_bg' : ''}`}>
      <div className="d-lg-flex">
        {
          image &&
          <div className="d-flex justify-content-center order-lg-1">
            <Image
              src={image}
              alt="Welcome Image"
              className="w-100 WelcomeSection_image"
            />
          </div>
        }
        <div className="WelcomeSection_content">
          <div className="col-lg-10">
            <div className="WelcomeSection_lead" dangerouslySetInnerHTML={SanitizeHtml(lead)} />
          </div>
        </div>
      </div>
    </div>
  );
}

WelcomeSection.propTypes = {
  lead: PropTypes.string.isRequired,
  image: PropTypes.string,
};

WelcomeSection.defaultProps = {
  title: undefined,
  image: undefined,
};

export default WelcomeSection;



// WEBPACK FOOTER //
// ./src/pages/Plans/WelcomeSection.js